import hash from './hash';
import HostChannel from './HostChannel';
import MultiplexChannel from './MultiplexChannel';
var CHANNEL_PASSTHROUGH = ['connected', 'failed', 'reconnecting', 'up', 'down', 'switching'];
/**
 * Manages subscriptions to channels within a multiplexed connection (via HostChannel)
 */

var MultiplexHost = /*#__PURE__*/function () {
  function MultiplexHost(options) {
    var _this = this;

    this.openChannels = {};
    this.host = new HostChannel('/channels@firehose', {
      ssl: options.ssl,
      host: options.host
    });
    this.host.on('message', function (message, frame) {
      var channel = _this.openChannels[hash(frame.channel)];

      if (channel) {
        channel.lastMessageSequence = frame.last_sequence;
        channel.emit('message', message, frame);
      } else {
        console.log("Dropping message to closed channel: " + frame.channel);
      }
    });
    this.host.on('error', function (error, frame) {
      if (error === void 0) {
        error = {};
      }

      var channel = _this.openChannels[hash(frame.channel)];

      if (channel) {
        if (error.type === 'UnauthorizedSubscription') {
          channel.emit('failed', error, frame);
        } else if (error.type === 'ExpiredSubscription') {
          _this.reconnectToChannel(channel);
        } else {
          channel.emit('error', error, frame);
        }
      } else {
        console.log("Dropping error (" + error.type + ") to closed channel: " + frame.channel);
      }
    });
    CHANNEL_PASSTHROUGH.forEach(function (eventName) {
      _this.host.on(eventName, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        for (var key in _this.openChannels) {
          if (_this.openChannels.hasOwnProperty(key)) {
            var _this$openChannels$ke; // eslint-disable-line no-prototype-builtins


            (_this$openChannels$ke = _this.openChannels[key]).emit.apply(_this$openChannels$ke, [eventName].concat(args));
          }
        }
      });
    });
  }

  var _proto = MultiplexHost.prototype;

  _proto.openChannel = function openChannel(channelPath, options) {
    var _this2 = this;

    var key = hash(channelPath);

    if (this.openChannels[key]) {
      this.openChannels[key].subscribe();
    } else {
      this.openChannels[key] = new MultiplexChannel(this.host, channelPath, options);
      this.openChannels[key].once('destroy', function () {
        delete _this2.openChannels[key];
      });
    }

    return this.openChannels[key];
  };

  _proto.reconnectToChannel = function reconnectToChannel(channel) {
    var _this3 = this;

    var preflight = channel.options.preflight ? channel.options.preflight() : Promise.resolve();
    channel.emit('reconnecting');
    this.host.unsubscribeFromChannel(channel);
    preflight.then(function () {
      _this3.host.subscribeToChannel(channel);
    })["catch"](function (e) {
      channel.emit('failed', 'Reconnection failed', e);
    });
  };

  return MultiplexHost;
}();

export { MultiplexHost as default };